import React, { Component } from "react";
import Slider from "react-slick";
import bg_vide from '../../videos/newvid.mp4'
export default class SimpleSlider extends Component {
  render() {
    const settings = {
      dots: false,
      arrows:false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000
    };
    return (
      <>
        
        <Slider {...settings}>
            <div  className="full-screen-block relative">
                <video autoPlay loop muted className="bg_video">
                    <source src={bg_vide} type="video/mp4"></source>
                </video>
                <div className="bg-dark"></div>
                <div className="sliderTitleBlock">
                    
                    <h1 className= "homeSliderTitle"> D&J MULTIFRÍO</h1>
                    <h3 className= "homeSliderTitleBottom">Venta de repuestos para refrigeración y aire acondicionado.</h3>
                </div>
            </div>
        </Slider>
      </>
    );
  }
}